import { useContext } from "react";
import ClassLevelContext from "src/context/classLevelContext.js";

const useClassLevel = () => {
  const value = useContext(ClassLevelContext);
  return value;
};

export default useClassLevel;
